import axios from '../../axios'
import { takeLatest, call, put, all, select } from 'redux-saga/effects'
import { createAction, Action } from 'redux-actions'
import savePlanSaga from '../savePlan/savePlanSaga.js'
import {
  setSessionStorage,
  getSessionStorage,
  clearSessionStorage
} from '../../../services/setSessionStorage'

import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  USER_TOS_DOCS,
  ACCEPT_DOC,
  ACCEPT_DOC_SUCCESS,
  ACCEPT_DOC_FAILURE
} from './actions.js'
export const actions = {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  USER_TOS_DOCS,
  ACCEPT_DOC,
  ACCEPT_DOC_SUCCESS,
  ACCEPT_DOC_FAILURE
}
// Saga action strings
type AuthSagaActionCreators = {
  login: () => Action<{ email: string, password: string }>,
  loginSuccess: number => Action<{ id: string }>,
  loginFailure: Object => Action<any>,
  setUserTOSDocs: (Array<any>) => Action<any>,
  acceptDocs: string => Action<string>,
  acceptDocsSuccess: any => Action<any>,
  acceptDocsFailure: Object => Action<any>
}

export const actionCreators: AuthSagaActionCreators = {
  login: createAction(LOGIN),
  loginSuccess: createAction(LOGIN_SUCCESS),
  loginFailure: createAction(LOGIN_FAILURE),
  setUserTOSDocs: createAction(USER_TOS_DOCS),
  acceptDocs: createAction(ACCEPT_DOC),
  acceptDocsSuccess: createAction(ACCEPT_DOC_SUCCESS),
  acceptDocsFailure: createAction(ACCEPT_DOC_FAILURE)
}

const isAuthorized = state => state.login.authorized

export default function * watchAuth () {
  // jest doesn't like importing login actions above because it creates a cyclical dependency which haste map
  // doesn't handle right
  yield takeLatest('Login/RESET', logout)
  try {
    const sessionToken = yield call(getSessionStorage)
    const authorized = yield select(isAuthorized)
    if (sessionToken && !authorized) {
      const userResponse = yield call(axios.get, '/user/me')
      const userNeedsToAcceptDocs = yield call(
        axios.get,
        'legal/docs/unaccepted'
      )
      yield put(actionCreators.setUserTOSDocs(userNeedsToAcceptDocs.data))
      yield put(actionCreators.loginSuccess(userResponse.data))
    }
  } catch (e) {
    console.error('autologin error', e)
  }

  yield takeLatest(LOGIN, login)
  yield takeLatest(ACCEPT_DOC, acceptDocs)
}

export function * logout () {
  yield call(clearSessionStorage)
}

export function * login (action) {
  try {
    const user = yield call(axios.post, 'auth/login', {
      email: action.payload.email,
      password: action.payload.password
    })
    yield call(setSessionStorage, user.data.token)
    const userNeedsToAcceptDocs = yield call(axios.get, 'legal/docs/unaccepted')
    yield put(actionCreators.setUserTOSDocs(userNeedsToAcceptDocs.data))
    yield put(actionCreators.loginSuccess(user.data))
  } catch (error) {
    if (error.response) {
      if (error.response.data.errors) {
        yield put(actionCreators.loginFailure(error.response.data.errors))
      } else {
        yield put(actionCreators.loginFailure(['somethingWrong']))
      }
    } else if (error.request) {
      yield put(actionCreators.loginFailure(error.request))
    } else {
      yield put(actionCreators.loginFailure(error.message))
    }
  }
}
export function * acceptDocs (action) {
  try {
    const acceptDoc = yield all(
      action.payload.map(doc =>
        call(axios.post, 'legal/docs/accept', {
          legalDocId: doc.id
        })
      )
    )
    yield put(actionCreators.acceptDocsSuccess(acceptDoc.data))
  } catch (error) {
    const userNeedsToAcceptDocs = yield call(axios.get, 'legal/docs/unaccepted')
    yield put(actionCreators.setUserTOSDocs(userNeedsToAcceptDocs.data))
  }
}

// export function * acceptDoc (action) {
//   try {
//     const acceptDoc = yield call(axios.post, 'legal/docs/accept', {
//       legalDocId: action.payload
//     })
//     yield put(actionCreators.acceptDocSuccess(acceptDoc.data))
//   } catch (error) {
//     const userNeedsToAcceptDocs = yield call(axios.get, 'legal/docs/unaccepted')
//     yield put(actionCreators.setUserTOSDocs(userNeedsToAcceptDocs.data))
//   }
// }



// WEBPACK FOOTER //
// ./src/redux/sagas/auth/authSaga.js